import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import providersMaster from '@/assets/recommend/providers.json'
import type {
  PositionedOffer,
  RecommendBlock
} from '@/composables/useRecommendJobBlocks'

interface ProviderMaster {
  label: string
  privacy_url: string
  apply_label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendJobList',
  props: {
    blocks: null,
    variant: { default: 'grid' },
    hideApplied: { type: Boolean, default: false },
    applyingKey: { default: '' }
  },
  emits: ["detail", "apply"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'detail', offer: PositionedOffer): void
  (e: 'apply', offer: PositionedOffer): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { blocks: RecommendBlock[], variant: 'grid' | 'list', hideApplied: boolean, applyingKey: string };





const master = providersMaster as Record<string, ProviderMaster>

/** hideApplied のときは応募済みを落とし、空になったブロックも消す */
const visibleBlocks = computed<RecommendBlock[]>(() => {
  const blocks = props.blocks || []
  if (!props.hideApplied) return blocks
  return blocks
    .map((block) => ({
      ...block,
      offers: (block.offers || []).filter((offer) => !offer.is_applied)
    }))
    .filter((block) => block.offers.length > 0)
})

/** 表示中の提供元（重複なし・ブロック順） */
const visibleProviders = computed(() => {
  const seen: string[] = []
  for (const block of visibleBlocks.value) {
    if (block && block.provider && seen.indexOf(block.provider) < 0) {
      seen.push(block.provider)
    }
  }
  return seen
})

function providerLabel(provider: string): string {
  return (master[provider] && master[provider].label) || provider
}

function providerPrivacyUrl(provider: string): string {
  return (master[provider] && master[provider].privacy_url) || ''
}

function providerApplyLabel(provider: string): string {
  return (master[provider] && master[provider].apply_label) || '応募する'
}

function isApplying(offer: PositionedOffer): boolean {
  if (!props.applyingKey) return false
  return props.applyingKey === `${offer.provider}-${offer.job_id}`
}

function employmentLabel(offer: PositionedOffer): string {
  const types = offer.employment_types
  if (!Array.isArray(types) || types.length === 0) return ''
  return types.filter(Boolean).join(' / ')
}

function truncate(text: string, maxLength: number): string {
  if (!text) return ''
  const flat = text.replace(/\s+/g, ' ').trim()
  if (flat.length <= maxLength) return flat
  return flat.slice(0, maxLength) + '…'
}

function onDetail(offer: PositionedOffer) {
  emit('detail', offer)
}

function onApply(offer: PositionedOffer) {
  emit('apply', offer)
}

return { __sfc: true,props, emit, master, visibleBlocks, visibleProviders, providerLabel, providerPrivacyUrl, providerApplyLabel, isApplying, employmentLabel, truncate, onDetail, onApply }
}

})